import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // Check if custom background/text colors are provided
  const hasCustomBg = className?.includes('bg-');
  const hasCustomText = className?.includes('text-') && !className?.includes('text-base') && !className?.includes('text-sm');
  
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        !hasCustomBg && "bg-white",
        !hasCustomText && "text-slate-900",
        "[&:-webkit-autofill]:!shadow-[0_0_0_9999px_white_inset]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
